import { Controller } from "@hotwired/stimulus"

// Directly embeds the AI canvas iframe for proposal pages
// This bypasses the ai-mode.js status check since proposals are for demo purposes
export default class extends Controller {
  static values = {
    canvasUrl: String
  }

  connect() {
    // Set initial height from data attribute
    const expandedHeight = this.element.dataset.expandedHeight || 800
    this.element.style.height = `${expandedHeight}px`

    this.embedIframe()
    this.boundHandleMessage = this.handleMessage.bind(this)
    window.addEventListener('message', this.boundHandleMessage)
  }

  disconnect() {
    window.removeEventListener('message', this.boundHandleMessage)
  }

  embedIframe() {
    // Check if already embedded
    if (this.element.querySelector('iframe')) {
      return
    }

    // Create and configure the iframe
    const iframe = document.createElement('iframe')
    iframe.src = this.canvasUrlValue
    iframe.setAttribute('allow', 'microphone; camera; autoplay; geolocation; fullscreen; display-capture; clipboard-read; clipboard-write')
    iframe.setAttribute('referrerpolicy', 'no-referrer')

    Object.assign(iframe.style, {
      position: 'absolute',
      inset: '0',
      width: '100%',
      height: '100%',
      border: '1px solid #e5e7eb',
      display: 'block',
      borderRadius: '16px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    })

    this.element.appendChild(iframe)
  }

  handleMessage(event) {
    if (!event.data) return

    // Ignore height updates - use fixed height from data-expanded-height
  }
}
